<template>
  <div class="app-container">
    <!-- 筛选/操作栏 -->
    <div class="filter-container">
      <el-input
        v-model.trim="listQuery.userId"
        placeholder="用户ID"
        style="width: 140px"
        class="filter-item"
        clearable
        @keyup.enter.native="handleFilter"
      />
      <el-input
        v-model.trim="listQuery.agentId"
        placeholder="代理商用户ID"
        style="width: 150px"
        class="filter-item"
        clearable
        @keyup.enter.native="handleFilter"
      />
      <el-select
        v-model="listQuery.teamLogo"
        placeholder="团队标识"
        style="width: 130px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in TEAM_LOGO_ENUM"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.statue"
        placeholder="状态"
        style="width: 130px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in AGENT_TASK_STATUS_ENUM"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>

      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
      >搜索</el-button>
      <el-button
        class="filter-item"
        icon="el-icon-refresh"
        @click="handleReset"
      >重置</el-button>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-plus"
        @click="handleCreate"
      >新增</el-button>
    </div>

    <!-- 数据列表 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
      style="width: 100%"
    >
      <el-table-column align="center" prop="id" label="ID" width="80" />
      <el-table-column align="center" prop="userId" label="用户ID" min-width="110" />
      <el-table-column align="center" prop="agentUserId" label="代理商用户ID" min-width="120" />
      <el-table-column align="center" prop="goodsId" label="商品ID" min-width="100" />
      <el-table-column align="center" prop="giftNum" label="礼包数量" min-width="100" />
      <el-table-column
        align="center"
        prop="regionAddress"
        label="地区地址"
        min-width="160"
        show-overflow-tooltip
      />
      <el-table-column align="center" prop="type" label="团队类型" width="110">
        <template slot-scope="scope">
          <span>{{ getValue(AGENT_TASK_TEAM_TYPE_ENUM, scope.row.type) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="state" label="任务状态" width="110">
        <template slot-scope="scope">
          <el-tag :type="getStatusTagType(scope.row.state)" size="small">
            {{ getValue(AGENT_TASK_STATUS_ENUM, scope.row.state) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="startTime" label="任务开始时间" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.startTime || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="endTime" label="任务结束时间" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.endTime || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="ctdate" label="创建时间" width="160">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="mddate" label="更新时间" width="160">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        width="100"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleReview(scope.row)"
          >审核</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 新增弹窗 -->
    <el-dialog
      title="新增考核任务"
      :visible.sync="createDialogVisible"
      width="580px"
      :append-to-body="true"
      :close-on-click-modal="false"
      @closed="handleCreateDialogClosed"
    >
      <el-form
        ref="createFormRef"
        :model="createForm"
        :rules="createRules"
        label-width="120px"
        size="small"
      >
        <el-form-item label="合伙人ID" prop="userId">
          <el-input
            v-model.trim="createForm.userId"
            placeholder="请输入合伙人ID"
            clearable
          />
        </el-form-item>
        <el-form-item label="代理商用户ID" prop="agentUserId">
          <el-input
            v-model.trim="createForm.agentUserId"
            placeholder="请输入代理商用户ID"
            clearable
          />
        </el-form-item>
        <el-form-item label="任务时间" prop="startTime">
          <DataPicker
            ref="taskDataPickerRef"
            @valueFunc="getPickerValueFunc"
            paramsType="task"
            type="datetimerange"
            startPlaceholder="任务开始时间"
            endPlaceholder="任务结束时间"
          />
        </el-form-item>
        <el-form-item label="商品ID" prop="goodsId">
          <el-input
            v-model.trim="createForm.goodsId"
            placeholder="请输入商品ID"
            clearable
          />
        </el-form-item>
        <el-form-item label="团队类型" prop="type">
          <el-select
            v-model="createForm.type"
            placeholder="请选择团队类型"
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="item in AGENT_TASK_TEAM_TYPE_ENUM"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="createDialogVisible = false">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="createSubmitLoading"
          @click="submitCreate"
        >确 定</el-button>
      </div>
    </el-dialog>

    <!-- 审核弹窗 -->
    <el-dialog
      title="考核任务审核"
      :visible.sync="reviewDialogVisible"
      width="480px"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <el-form :model="reviewForm" label-width="110px" size="small">
        <el-form-item label="考核任务ID">
          <span>{{ reviewForm.taskId }}</span>
        </el-form-item>
        <el-form-item label="合伙人ID" v-if="reviewCurrentRow">
          <span>{{ reviewCurrentRow.userId }}</span>
        </el-form-item>
        <el-form-item label="代理商用户ID" v-if="reviewCurrentRow">
          <span>{{ reviewCurrentRow.agentUserId }}</span>
        </el-form-item>
        <el-form-item label="审核状态" required>
          <el-radio-group v-model="reviewForm.status">
            <el-radio
              v-for="item in AGENT_TASK_STATUS_ENUM"
              :key="item.key"
              :label="item.key"
            >{{ item.value }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="reviewDialogVisible = false">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="reviewSubmitLoading"
          @click="submitReview"
        >保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAgentPartnerTaskList,
  reviewAgentTask,
  addAgentTask
} from "@/api/agentPartnerTask";
import { formatApiDate } from "@/utils/utils";
import {
  getValue,
  TEAM_LOGO_ENUM,
  AGENT_TASK_STATUS_ENUM,
  AGENT_TASK_TEAM_TYPE_ENUM
} from "@/utils/enumUtile";
import DataPicker from "@/views/components/dataPicker.vue";

export default {
  name: "PartnerTask",
  components: {
    DataPicker
  },
  data() {
    return {
      TEAM_LOGO_ENUM,
      AGENT_TASK_STATUS_ENUM,
      AGENT_TASK_TEAM_TYPE_ENUM,

      list: [],
      total: 0,
      listLoading: false,

      // 查询参数
      listQuery: {
        page: 1,
        pageSize: 10,
        userId: undefined,
        agentId: undefined,
        teamLogo: undefined,
        statue: undefined
      },

      // 新增弹窗
      createDialogVisible: false,
      createSubmitLoading: false,
      createForm: {
        userId: "",
        agentUserId: "",
        startTime: "",
        endTime: "",
        goodsId: "",
        type: undefined
      },
      createRules: {
        userId: [{ required: true, message: "请输入合伙人ID", trigger: "blur" }],
        agentUserId: [
          { required: true, message: "请输入代理商用户ID", trigger: "blur" }
        ],
        startTime: [
          { required: true, message: "请选择任务时间", trigger: "change" }
        ],
        goodsId: [{ required: true, message: "请输入商品ID", trigger: "blur" }],
        type: [
          { required: true, message: "请选择团队类型", trigger: "change" }
        ]
      },

      // 审核弹窗
      reviewDialogVisible: false,
      reviewSubmitLoading: false,
      reviewCurrentRow: null,
      reviewForm: {
        taskId: undefined,
        status: 0
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getValue,
    formatApiDate,

    // 获取列表
    getList() {
      this.listLoading = true;
      const params = {
        page: this.listQuery.page,
        pageSize: this.listQuery.pageSize
      };
      if (this.listQuery.userId !== undefined && this.listQuery.userId !== "") {
        params.userId = this.listQuery.userId;
      }
      if (this.listQuery.agentId !== undefined && this.listQuery.agentId !== "") {
        params.agentId = this.listQuery.agentId;
      }
      if (this.listQuery.teamLogo !== undefined && this.listQuery.teamLogo !== "") {
        params.teamLogo = this.listQuery.teamLogo;
      }
      if (this.listQuery.statue !== undefined && this.listQuery.statue !== "") {
        params.statue = this.listQuery.statue;
      }

      getAgentPartnerTaskList(params)
        .then(res => {
          if (res && res.data) {
            this.list = res.data.entitys || [];
            this.total = res.data.totalCount || 0;
          } else {
            this.list = [];
            this.total = 0;
          }
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },

    // 搜索
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },

    // 重置
    handleReset() {
      this.listQuery.page = 1;
      this.listQuery.pageSize = 10;
      this.listQuery.userId = undefined;
      this.listQuery.agentId = undefined;
      this.listQuery.teamLogo = undefined;
      this.listQuery.statue = undefined;
      this.getList();
    },

    // 分页尺寸改变
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },

    // 接收时间组件回调
    getPickerValueFunc(type, value) {
      if (type === "task") {
        if (value && value.length >= 2) {
          this.createForm.startTime = value[0];
          this.createForm.endTime = value[1];
        } else {
          this.createForm.startTime = "";
          this.createForm.endTime = "";
        }
        if (this.$refs.createFormRef) {
          this.$refs.createFormRef.validateField("startTime");
        }
      }
    },

    // 打开新增弹窗
    handleCreate() {
      this.createForm = {
        userId: "",
        agentUserId: "",
        startTime: "",
        endTime: "",
        goodsId: "",
        type: undefined
      };
      this.createDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.taskDataPickerRef) {
          this.$refs.taskDataPickerRef.timeValue = [];
        }
        if (this.$refs.createFormRef) {
          this.$refs.createFormRef.clearValidate();
        }
      });
    },

    // 关闭新增弹窗重置
    handleCreateDialogClosed() {
      if (this.$refs.taskDataPickerRef) {
        this.$refs.taskDataPickerRef.timeValue = [];
      }
      if (this.$refs.createFormRef) {
        this.$refs.createFormRef.clearValidate();
      }
    },

    // 提交新增
    submitCreate() {
      this.$refs.createFormRef.validate(valid => {
        if (!valid) return;
        this.createSubmitLoading = true;
        addAgentTask(this.createForm)
          .then(res => {
            this.createSubmitLoading = false;
            if (res && (res.bizcode === 100 || res.bizcode === 0)) {
              this.$message.success("新增成功");
              this.createDialogVisible = false;
              this.getList();
            }
          })
          .catch(() => {
            this.createSubmitLoading = false;
          });
      });
    },

    // 打开审核弹窗
    handleReview(row) {
      this.reviewCurrentRow = row;
      this.reviewForm = {
        taskId: row.id,
        status:
          row.state !== undefined && row.state !== null ? Number(row.state) : 0
      };
      this.reviewDialogVisible = true;
    },

    // 保存审核状态
    submitReview() {
      this.reviewSubmitLoading = true;
      reviewAgentTask({
        taskId: this.reviewForm.taskId,
        status: this.reviewForm.status
      })
        .then(res => {
          this.reviewSubmitLoading = false;
          if (res && (res.bizcode === 100 || res.bizcode === 0)) {
            this.$message.success("审核状态保存成功");
            this.reviewDialogVisible = false;
            this.getList();
          }
        })
        .catch(() => {
          this.reviewSubmitLoading = false;
        });
    },

    // 状态标签类型
    getStatusTagType(status) {
      const map = {
        0: "warning", // 进行中
        1: "danger",  // 未完成
        2: "success"  // 已完成
      };
      return map[Number(status)] || "info";
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-container {
  margin-bottom: 20px;
  .filter-item {
    margin-right: 10px;
    margin-bottom: 10px;
    vertical-align: middle;
  }
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>
